import * as React from "react";
import { connect } from "react-redux";
import {
  setUser,
  setAlert,
  setTemp,
  setGallery,
  setImage,
  setIptc,
  setMeta,
} from "../../actions";
import PreviewView from "./view";
import { usePreviewViewModel } from "./viewModel";
import { usePreviewStyles } from "./styles";

function Preview(props) {
  const classes = usePreviewStyles();
  const viewModel = usePreviewViewModel({
    ...props,
    classes,
  });

  return (
    <PreviewView viewModel={viewModel} />
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  temp: state.temp,
  alert: state.alert,
  gallery: state.gallery,
  image: state.image,
  iptc: state.iptc,
  meta: state.meta,
});

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch(setUser(user)),
  setAlert: (alert) => dispatch(setAlert(alert)),
  setTemp: (temp) => dispatch(setTemp(temp)),
  setGallery: (gallery) => dispatch(setGallery(gallery)),
  setImage: (image) => dispatch(setImage(image)),
  setIptc: (iptc) => dispatch(setIptc(iptc)),
  setMeta: (meta) => dispatch(setMeta(meta)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
